<template>
    <div class="consent-optin-update-form">
        <h1 class="consent-optin-update-form__title typographies-heading-h1">
            {{ labels.title }}
        </h1>

        <p class="consent-optin-update-form__information typographies-paragraph-medium-regular">
            {{ labels.information }}
        </p>

        <div class="consent-optin-update-form__campaigns">
            <CompassSwitch
                v-model="currentConsent.marketing.email"
                :label="labels.switchButtons.email.label"
                orientation="left"
                class="consent-optin-update-form__campaigns-swicth"
            />

            <CompassSwitch
                v-model="currentConsent.marketing.sms"
                :label="labels.switchButtons.sms.label"
                orientation="left"
                class="consent-optin-update-form__campaigns-swicth"
            />
        </div>

        <CompassButton
            class="consent-optin-update-form__button"
            :label="labels.button"
            @click="updateConsent"
        />

        <preloader :display="isLoading" />
    </div>
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';

export default {
    components: { Preloader },
    props: {
        doubleOptin: {
            type: Boolean,
            required: true,
        },
        consent: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            isLoading: false,
            currentConsent: {
                marketing: {
                    email: this.consent['email'],
                    sms: this.consent['sms'],
                    phone: false,
                    postal_mail: false,
                    custom: false,
                },
            },
            labels: {
                title: this.$l10n.__('Mise à jour des inscriptions aux campagnes marketing'),
                information: this.$l10n.__(
                    "Vous pouvez modifier vos préférences d'inscription aux campagnes marketing",
                ),
                switchButtons: {
                    email: {
                        label: this.$l10n.__('Campagnes email'),
                    },
                    sms: {
                        label: this.$l10n.__('Campagnes SMS'),
                    },
                },
                button: this.$l10n.__('Enregistrer mes informations'),
            },
        };
    },
    methods: {
        async updateConsent() {
            this.isLoading = true;
            const currentLocation = window.location.href;

            this.$ajax.post(
                currentLocation,
                {},
                this.currentConsent,
                () => {
                    this.$pushToast({
                        type: 'success',
                        icon: true,
                        text: this.$l10n.__(
                            this.doubleOptin
                                ? 'Un email de confirmation vous a été envoyé pour valider la mise à jour de vos inscriptions.'
                                : 'Vos inscriptions aux campagnes marketing sont maintenant à jour.',
                        ),
                    });
                    this.isLoading = false;
                },
                () => {
                    this.$pushToast({
                        type: 'error',
                        icon: true,
                        text: this.$l10n.__('Une erreur est survenue, merci de réessayer'),
                    });
                    this.isLoading = false;
                },
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.consent-optin-update-form {
    display: flex;
    gap: var(--spacing-2);
    align-items: center;
    flex-direction: column;
    justify-content: center;

    &__title,
    &__information {
        margin: 0;
    }

    &__campaigns {
        display: flex;
        gap: var(--spacing-2);
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        padding: var(--spacing-1) var(--spacing-2);
    }
}
</style>
